import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
// import logoImage from "../../../../../../assets/images/PalletTraderPlus.svg"
// import logoImage from "../../../../../assets/images/PalletTraderPlus.svg";
import LogoImage from "../../../../../assets/svg/Logo";
import nounImage from "../../../../../assets/images/noun-trending.svg";
import nounPartner from "../../../../../assets/images/noun-partner.svg";
import connectImage from "../../../../../assets/images/platform.png";
// import PalletTraderWarehousePhone from "web/assets/images/LandingPageImage.png";
import PalletTraderWarehousePhone from "web/assets/images/home-pallate-image.png";

import AOS from "aos";
import styled from "styled-components";

import {
  Container,
  Wrapper,
} from "web/pages/public/landing-page/StartPage/CarouselHomepage/CarouselHomepageStyled";

const CarouselHomepage = (args) => {
  let history = useHistory();

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 320,
    });
  }, []);
  return (
    <Container>
      <Wrapper>
        <div className="carousel-img-container d-none d-sm-flex">
          <div className="text-box">
            <h2>TECHNOLOGY MAKES IT POSSIBLE.</h2>
            <h2>
              THE LARGEST ONLINE NETWORK OF PALLET SUPPLIERS MAKES IT POWERFUL.
            </h2>
            <h2>THIS IS PALLET PROCUREMENT FOR THE 21ST CENTURY.</h2>
          </div>

          <img
            src={PalletTraderWarehousePhone}
            className="carousel-img"
            alt="carouselImage"
          />
        </div>
        <div className="carousel-img-container  d-sm-none">
          <div className="text-box">
            <h2>TECHNOLOGY MAKES IT POSSIBLE.</h2>
            <h2>
              THE LARGEST ONLINE NETWORK OF PALLET SUPPLIERS MAKES IT POWERFUL.{" "}
            </h2>
            <h2>THIS IS PALLET PROCUREMENT FOR THE 21ST CENTURY.</h2>
          </div>

          <img
            src={PalletTraderWarehousePhone}
            className="carousel-img"
            alt="carouselImage"
          />
        </div>
        <Modal
          isOpen={modal}
          toggle={toggle}
          {...args}
          size="lg"
          style={{ marginTop: "85px" }}
        >
          <PopupContainer
            onClick={() => {
              setModal(!modal);
            }}
          >
            <div className="Header">
              <div>
                <h6 style={{ fontSize: "16px", marginBottom: "5px" }}>
                  Announcing
                </h6>
                <div>
                  <LogoImage />
                </div>
              </div>
            </div>

            <div className="ptplusModal">
              <center>
                PalletTrader
                <span style={{ position: "relative", top: "-3px" }}>+</span> is
                the best of what the PalletTrader marketplace has to offer,
                managed for you.{" "}
              </center>
              <center>
                Tell us what you need, and we’ll secure pallet supply and
                oversee the order process.
              </center>
            </div>
            <div style={{ color: "#005586", padding: "", fontSize: "14px" }}>
              <br />
              <strong>How it works</strong>
              <ul
                style={{ listStyle: "disc", margin: "0", paddingLeft: "18px" }}
              >
                <li>
                  Interactive online portal to request, modify and monitor your
                  pallet orders, inception through delivery.
                </li>
                <li>
                  Dedicated account representative to manage the order
                  procurement process.
                </li>
                <li>
                  Tracking team that will monitor your daily shipments to ensure
                  on-time delivery.
                </li>
                <li>
                  Centralized access to download and audit invoices and PODs,
                  with robust reporting.
                </li>
                <li>
                  {" "}
                  KPI dashboard for at-a-glance order and cost trends by
                  location, and across your network.
                </li>
              </ul>
              <br />
              <FooterContainer style={{ display: "flex" }}>
                <div style={{ flex: "1 1 100%" }}>
                  <strong>What you'll get</strong>
                  <div className="ThreePicBox">
                    <div className="InerBox">
                      <div>
                        <img
                          style={{ width: "80%" }}
                          src={connectImage}
                          alt=""
                        ></img>
                        <br></br>
                      </div>
                      <div style={{ textAlign: "center", lineHeight: "17px" }}>
                        <span
                          style={{
                            color: "#005586",
                            fontSize: "11px",
                            fontWeight: "bold",
                            lineHeight: "1px",
                          }}
                        >
                          PalletTrader platform and technology
                        </span>
                      </div>
                    </div>
                    <div className="InerBox">
                      <div>
                        <img src={nounPartner} alt=""></img>
                      </div>
                      <div style={{ textAlign: "center", lineHeight: "17px" }}>
                        <span
                          style={{
                            color: "#005586",
                            fontSize: "11px",
                            fontWeight: "bold",
                          }}
                        >
                          Dedicated Account Rep
                        </span>
                      </div>
                    </div>
                    <div className="InerBox">
                      <div>
                        <img src={nounImage} alt=""></img>
                        <br></br>
                      </div>
                      <div style={{ textAlign: "center", lineHeight: "17px" }}>
                        <span
                          style={{
                            color: "#005586",
                            fontSize: "11px",
                            fontWeight: "bold",
                          }}
                        >
                          Dashboard for complete transaction visibility
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    flex: "0 1 35%",
                    background: "#005586",
                    padding: "10px 15px",
                    color: "#ffffff",
                    textAlign: "center",
                    fontSize: "13px",
                  }}
                >
                  Want to learn more about how PalletTrader
                  <span style={{ position: "relative", top: "-3px" }}>
                    +
                  </span>{" "}
                  can work for you? Contact: <br></br>
                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: "#f7b018",
                    }}
                  >
                    Kevin Kull <br></br>732-454-9790
                    <br />
                    kevin.kull@pallettrader.com
                  </span>
                </div>
              </FooterContainer>
            </div>
          </PopupContainer>
        </Modal>
      </Wrapper>
    </Container>
  );
};

export default CarouselHomepage;
const FooterContainer = styled.div`
  display: flex;
  .ThreePicBox {
    display: flex;
    margin-right: 20px;
    .InerBox {
      width: 33.3%;
      > div:first-child {
        height: 100px;
        text-align: center;

        img {
          object-fit: contain;
          max-width: 100%;
          height: auto;
          width: 70%;
        }
      }
    }
    @media (max-width: 991px) {
      margin-right: 0;
      margin-bottom: 10px;
    }
    @media (max-width: 500px) {
      .InerBox {
        > div:first-child {
          height: 80px;
        }
      }
    }
  }
  @media (max-width: 991px) {
    flex-direction: column;
  }
`;
const PopupContainer = styled.div`
  padding: 10px 60px 30px;
  cursor: pointer;
  .Header {
    display: flex;
    justify-content: center;
    > div {
      display: inline-block;
      padding: 10px 10px 20px;
      h6 {
        font-weight: 600;
        color: #f6af18;
      }
    }
  }
  .ptplusModal {
    padding: 5px 5px;
    background-color: #f6af18;
    color: #005586;
    font-weight: bold;
    @media (max-width: 991px) {
      padding: 10px;
      cursor: pointer;
    }
  }
  @media (max-width: 991px) {
    padding: 20px;
  }
`;
const ManageServiceBox = styled.div`
  background: rgb(247, 176, 24);
  padding: 2px;
  width: 200px;
  right: 0;
  position: absolute;
  z-index: 99;
  top: 0;
  @media (max-width: 767px) {
    position: unset;
  }

  .showMeServiceBtn {
    font-size: 12px;
    background-color: white;
    border-radius: 10px;
    color: #005586;
    border: 1px solid transparent;
    :hover {
      border-color: blue;
      font-size: 14px;
    }
  }
`;
